import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../../styles";
import {PDFContext} from "../../BasePDF";


export const PurchaseDealerPriceBreakdownPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{...baseStyles.marginRight, ...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Price Breakdown</Text>
            </View>

            <View>
                <View style={baseStyles.flexBetween}>
                    <Text>Vehicle Cost</Text>
                    <Text>{pdfData.vehicle_cost.toDollarFormat()}</Text>
                </View>

                <View style={baseStyles.flexBetween}>
                    <Text>Vehicle Profit</Text>
                    <Text>{pdfData.vehicle_profit.toDollarFormat()}</Text>
                </View>

                {/*<View style={{...baseStyles.flexBetween}}>*/}
                {/*    <Text>Customer Rebate (Disc)</Text>*/}
                {/*    <Text>{pdfData.total_rebates.toDollarFormat()}</Text>*/}
                {/*</View>*/}

                <View style={{...baseStyles.boldTopBorder, ...baseStyles.flexBetween}}>
                    <Text>Total Cash Price</Text>
                    <Text>{pdfData.total_cash_price.toDollarFormat()}</Text>
                </View>
            </View>
        </View>
    )
}